import React, { useState } from 'react';
import './payroll.css'
import MyTable from '../../components/Schedule/MyTable';
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';

const ListView = ({ data, refresh }) => {
    const [deletModal, setDeleteModal] = useState(false)
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleDeleteClick = (record) => {
        setSelectedRecord(record);
        setDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!selectedRecord) return;
        try {
            const response = await ApiService.post('/payroll/delete-payrollRecord', {
                Shift_Number: selectedRecord.shift_number,
                Shift_Date: selectedRecord.shift_date
            });
            toast.success(response.message)
            refresh()
            setDeleteModal(false);
        } catch (error) {
            toast.error(error.message)
        }
    };

    const columns = [
        {
            field: 'date', headerName: 'Date', flex: 1, minWidth: 120, sortable: false,
            valueGetter: (params) => params.row.shift_date
        },
        {
            field: 'name', headerName: 'Name', flex: 1, minWidth: 150, sortable: false,
            valueGetter: (params) => params.row.employee_name
        },
        {
            field: 'runNumber', headerName: 'Run Number', flex: 1, minWidth: 120, sortable: false,
            valueGetter: (params) => params.row.assignment_code
        },
        {
            field: 'reason', headerName: 'Reason', flex: 1, minWidth: 200, sortable: false,
            valueGetter: (params) => params.row.detail_text
        },
        {
            field: 'start', headerName: 'Start', flex: 1, minWidth: 120, sortable: false,
            valueGetter: (params) => params.row.start_time
        },
        {
            field: 'end', headerName: 'End', flex: 1, minWidth: 120, sortable: false,
            valueGetter: (params) => params.row.end_time
        },
        {
            field: 'hours', headerName: 'Hours', flex: 1, minWidth: 120, sortable: false,
            valueGetter: (params) => params.row.hours
        },
        {
            field: 'paycode', headerName: 'Paycode', flex: 1, minWidth: 120, sortable: false,
            valueGetter: (params) => params.row.pay_code
        },
        {
            field: 'createdBy', headerName: 'Created by', flex: 1, minWidth: 200, sortable: false,
            valueGetter: (params) => params.row.created_by
        },
        {
            field: 'timestamp', headerName: 'Timestamp', flex: 1, minWidth: 180, sortable: false,
            valueGetter: (params) => params.row.create_time
        },
        {
            field: 'inDayShift', headerName: 'Action', flex: 1, minWidth: 120,
            renderCell: (params) => {
                return (
                    <div style={{ gap: 10, display: 'flex' }}>
                        <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                            onClick={() => handleDeleteClick(params.row)}
                        />
                    </div>
                );
            }
        },
    ]
    return (
        <>
                <MyTable
                    rows={data}
                    columns={columns}
                    hideFooter={true}
                    checkboxSelection={false}
                />
            <Modal show={deletModal} onHide={() => setDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Record</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure to delete this Record?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
                                Cancel
                            </ButtonTheme>
                        </Col>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleDelete}>
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ListView;